import { useTranslation } from 'react-i18next';
import { Stack, Text } from 'shell/components';

const QuestionCard = ({ question, mobile }) => {
    const { t } = useTranslation('quiz');

    return (
        <Stack
            component={'article'}
            direction={mobile ? 'column' : 'row'}
            alignItems={'flex-start'}
            justifyContent={'space-between'}
            spacing={4}
            sx={(theme) => ({
                width: '100%',
                p: mobile ? 4 : 5,
                border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
                borderRadius: '16px',
            })}
        >
            <Text
                component={'div'}
                variant={'p1'}
                weight={'medium'}
                rich={question.rich}
                sx={{
                    minWidth: 0,
                    '& img, & video, & iframe': { maxWidth: '100%' },
                    '& table': { display: 'block', maxWidth: '100%', overflowX: 'auto' },
                }}
            >
                {question.content || t('create.question-missing-content', 'Question text is unavailable.')}
            </Text>
            <Text
                weight={'medium'}
                sx={(theme) => ({
                    flexShrink: 0,
                    whiteSpace: 'nowrap',
                    borderRadius: '40px',
                    px: 2,
                    py: 1,
                    background: question.isTimelyGraded
                        ? theme.palette.ensightful.primary[50]
                        : theme.palette.ensightful.neutral[100],
                    color: question.isTimelyGraded
                        ? theme.palette.ensightful.primary[700]
                        : theme.palette.ensightful.neutral[900],
                })}
            >
                {t('create.points', 'Points: {{points}}', { points: question.points })}
            </Text>
        </Stack>
    );
};

export default QuestionCard;
